import { Color } from "flavr-math";
import { ConnectionLineTypes } from "flavr-common";
import { ConnectionRenderer } from "./connection.renderer";
const tempColor = new Color();
const DEFAULT_FUSSYNESS = 0;
const DEFAULT_NOISE_FREQUENCY = 10;
const DEFAULT_NOISE_VELOCITY = 0.0001;
function getValueOrDefault(value, defaultValue) {
    return value !== undefined ? value : defaultValue;
}
export class FlowConnectionRenderer extends ConnectionRenderer {
    constructor(name, from, to, params) {
        super(name, from, to);
        this.params = params;
    }
    destroy() {
        super.destroy();
        this.instance && this.instance.destroy();
        this.instance = undefined;
    }
    setVisible(visible) {
        this.instance && this.instance.setVisible(visible);
    }
    update(params) {
        if (params.type === ConnectionLineTypes.Flow) {
            this.params = params;
            if (this.instance) {
                this.instance.setColor(tempColor.setHex(this.params.lineColor));
                this.instance.setThickness(this.params.lineThickness);
                this.instance.setFuzzyness(getValueOrDefault(this.params.lineFussyness, DEFAULT_FUSSYNESS));
                this.instance.setNoiseFrequency(getValueOrDefault(this.params.lineNoiseFrequency, DEFAULT_NOISE_FREQUENCY));
                this.instance.setNoiseVelocity(getValueOrDefault(this.params.lineNoiseVelocity, DEFAULT_NOISE_VELOCITY));
            }
            return true;
        }
        return false;
    }
    updateStartAndEndPoints(start, end) {
        if (!this.instance)
            this.instance = this.createInstance();
        this.instance.setStartPoint(start);
        this.instance.setEndPoint(end);
    }
    createInstance() {
        const batch = this.from.renderer.getLineBatch(this.from.modelUID);
        const instance = batch.createInstance();
        instance.setColor(tempColor.setHex(this.params.lineColor));
        instance.setThickness(this.params.lineThickness);
        instance.setFuzzyness(getValueOrDefault(this.params.lineFussyness, DEFAULT_FUSSYNESS));
        instance.setNoiseFrequency(getValueOrDefault(this.params.lineNoiseFrequency, DEFAULT_NOISE_FREQUENCY));
        instance.setNoiseVelocity(getValueOrDefault(this.params.lineNoiseVelocity, DEFAULT_NOISE_VELOCITY));
        instance.setVisible(this.from.visible && this.to.visible);
        return instance;
    }
}
